export default "__VITE_ASSET__CRQSc4sZ__"